import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "loader flex flex-col items-center justify-center py-6" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "small-loader" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "small-loader" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLoader',
  props: {
  type: {
    type: String
  }
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.type)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (__props.type === 'small')
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}
}

})